<template>
  <div id="support">
    <main>
      <div class="outer-wrapper">
        <h2>Contrology<sup>®</sup> Support</h2>
        <div class="inner-wrapper">
          <p>We're here to support your Contrology apparatus needs!</p>
          <p>Click on your equipment category below to access User Guide, Assembly Guide, "How To" videos and FAQs. Thank you for choosing Contrology apparatus!</p>
          <nav>
            <a href="support-reformer">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-reformer@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-reformer@2x.jpg 2x"
                alt="Reformer product photo thumbnail"
                class="product-thumbnail"
              >
              Reformer
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-reformer-with-tower">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-tower@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-tower@2x.jpg 2x"
                alt="Reformer with Tower product photo thumbnail"
                class="product-thumbnail"
              >
              Reformer with Tower
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-cadillac">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-cadillac@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-cadillac@2x.jpg 2x"
                alt="Cadillac product photo thumbnail"
                class="product-thumbnail"
              >
              Cadillac
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-armchair">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-armchair@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-armchair@2x.jpg 2x"
                alt="Arm Chair product photo thumbnail"
                class="product-thumbnail"
              >
              Arm Chair
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-pedopul">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-pedopul@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-pedopul@2x.jpg 2x"
                alt="Ped-o-Pul product photo thumbnail"
                class="product-thumbnail"
              >
              Ped-o-Pul
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-foldingmat">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-foldingmat@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-foldingmat@2x.jpg 2x"
                alt="Folding Mat product photo thumbnail"
                class="product-thumbnail"
              >
              Folding Mat
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-ladderbarrel">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/th-ladderbarrel@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/th-ladderbarrel@2x.jpg 2x"
                alt="Ladder Barrel product photo thumbnail"
                class="product-thumbnail"
              >
              Ladder Barrel
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-wundachair">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/WundaChair_support_thumb@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/WundaChair_support_thumb@2x.jpg 2x"
                alt="Wunda Chair product photo thumbnail"
                class="product-thumbnail"
              >
              Wunda Chair
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-spinecorrector">
              <img
                src="https://s3.amazonaws.com/s3.pilates.com/contrology/SpineCorrector_support_thumb@1x.jpg"
                srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/SpineCorrector_support_thumb@2x.jpg 2x"
                alt="Spine Corrector product photo thumbnail"
                class="product-thumbnail"
              >
              Spine Corrector
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-walltower">
              <img
                src="https://contrology.pilates.com/logo-contrology-auth0.png"
                srcset="https://contrology.pilates.com/logo-contrology-auth0.png 2x"
                alt="Wall Tower product photo thumbnail"
                class="product-thumbnail"
              >
              Wall Tower
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-highmat">
              <img
                src="https://contrology.pilates.com/logo-contrology-auth0.png"
                srcset="https://contrology.pilates.com/logo-contrology-auth0.png 2x"
                alt="High Mat product photo thumbnail"
                class="product-thumbnail"
              >
              High Mat
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
            <a href="support-smallbarrel">
              <img
                src="https://contrology.pilates.com/logo-contrology-auth0.png"
                srcset="https://contrology.pilates.com/logo-contrology-auth0.png 2x"
                alt="High Mat product photo thumbnail"
                class="product-thumbnail"
              >
              Small Barrel
              <img src="@/assets/icon-standard-arrow-right.svg" alt="Right arrow icon" class="icon">
            </a>
          </nav>
          <div class="lower-links">
            <div class="flex-stack">
              <!-- <a href="https://s3.amazonaws.com/s3.pilates.com/resources/Contrology_WeightLimits_CapitalEquipment.pdf" class="link">Equipment Weight Limits</a> -->
              <a href="warranty" class="link">Returns &amp; Warranty</a>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'support',

    metaInfo: {
      title: "Contrology Support - Contrology Assembly, User Guides & Maintenance",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Find the help you need with your Contrology Pilates equipment. Go here to find Assembly Instructions, User Guides, Maintenance  Guides, commonly asked questions & more."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-support.jpg"
        }
      ]
    }
  }
  
</script>

<style scoped lang="scss">
.outer-wrapper {
  max-width: 518px;
  display: flex;
  flex-flow: column nowrap;
  margin: 0 auto;
}

nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 30px 0;
}

nav a {
  text-transform: uppercase;
  font-family: var(--roboto);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: var(--black);
  text-decoration: none;
  border-bottom: 2px solid var(--black);
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}

nav a:first-of-type {
  border-top: 2px solid var(--black);
}

.lower-links {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.link {
  font-family: var(--roboto);
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: 400;
  color: var(--black);
  text-decoration: underline;
  display: inline-block;
}

.affirm-link {
  text-decoration: none;
  color: var(--black);

}

.product-thumbnail {
  display: none;
}

.flex-stack {
  display: flex;
  flex-flow: column nowrap;
}

@media only screen and (max-width: 500px) {
  .lower-links {
    flex-flow: column nowrap;
    align-items: flex-start;
  }
}

@media only screen and (min-width: 1024px) {
  h2 {
    margin-bottom: 40px;
  }

  .inner-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    padding: 40px 50px;
  }

  nav a {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 0;
  }

  .product-thumbnail {
    display: block;
    margin-right: 10px;
    height: 64px;
    width: 64px;
  }

  .icon {
    margin-left: auto;
  }
}
</style>
